export const getAddCourseAction = (courseCode, sections = []) => (
    {
        type: 'ADD_COURSE',
        payload: { courseCode, sections },
    }
);

export const getSetCourseSectionsAction = (courseCode, sections) => (
    {
        type: 'SET_COURSE_SECTIONS',
        payload: {
            courseCode,
            sections,
        }
    }
);

export const getRemoveCourseAction = courseCode => (
    {
        type: 'REMOVE_COURSE',
        payload: { courseCode },
    }
);

export const getHydrateTimetableAction = timetable => (
    {
        type: 'HYDRATE_TIMETABLE',
        payload: {
            timetable,
        }
    }
);
